import { useState } from "react";
import ButtonNavigatorComponent from "../../../components/ButtonNavigator";
import { TableComponent } from "../../../components/Table v2";
import { convertDate } from "../../../libs/dateUtils";
import { arrayDiff } from "../../../libs/verefyDiffsList";
import { IHistoryJson } from "../model";

const THEADERMOCKMODAL = ["Data", "Nome", "Salário", "Cargos", "Projetos", "Cliente"];

export function ContentModal({ listRender, needModal, needSpinner, setName }: any) {
  const [pageModal, setPageModal] = useState(0);
  const [selectSizeModal, setSelectSizeModal] = useState(8);

  const listModal = listRender?.map((data: any) => data?.user_id === needModal && data)?.filter(Boolean);
  setName(listModal[0]?.json_now?.name);

  function mapArr(data: any) {
    const dataRender = data;
    if (!dataRender?.length) return "";
    return dataRender?.map((indexArr: any) => indexArr)?.join(" | ");
  }

  function verefyPay(data: any) {
    if (!data?.json_now?.pay || data?.json_now?.pay === "undefined") return "";
    return data?.json_now?.pay;
  }

  function verefyJobRole(data: any) {
    if (!data?.json_now?.job_role?.length) return "";
    return data?.json_now?.job_role?.map((role: any) => role)?.join(" | ");
  }

  function verefyDiffsPay(data: IHistoryJson) {
    const condition1 = data?.json_now?.pay;
    const condition2 = data?.json_old?.pay;
    const diffs = condition1 === condition2;
    return diffs;
  }

  function verefyDiffsInArr(condition1: any, condition2: any) {
    const dataDiff = arrayDiff(condition1 || [], condition2 || []);

    const diferentes = !!dataDiff?.length;
    return diferentes;
  }

  function listRenderObserverThePage(indexOfLine: number) {
    const initialListRender = indexOfLine < (pageModal + 1) * selectSizeModal;
    const endListRender = indexOfLine >= pageModal * selectSizeModal;
    return initialListRender && endListRender;
  }

  return (
    <div className="scroll-85">
      <TableComponent className="table-container-header-body">
        <thead>
          <tr>
            {THEADERMOCKMODAL?.map((headers: string) => {
              return (
                <th>
                  <span className={`flex ${headers === "Cliente" ? "pl-2" : ""}`}>{headers}</span>
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody className="tbody-history">
          {listModal?.map((dataRender: IHistoryJson, index: number) => {
            return (
              listRenderObserverThePage(index) && (
                <>
                  <tr key={dataRender?.id}>
                    <>
                      <td className="tdDataAndPay padding-1-rem">{convertDate(dataRender?.created_at)}</td>
                      <td className="tdName padding-1-rem">{dataRender?.json_now?.name}</td>
                      <td className={`tdDataAndPay padding-1-rem ${!verefyDiffsPay(dataRender) && "text-red"}`}>{verefyPay(dataRender)}</td>
                      <td
                        className={`td-jobRole padding-1-rem ${
                          verefyDiffsInArr(dataRender?.json_now?.job_role, dataRender?.json_old?.job_role) && "text-red"
                        }`}
                      >
                        {verefyJobRole(dataRender)}
                      </td>
                      <td
                        className={`td-project padding-1-rem ${
                          !verefyDiffsInArr(dataRender?.json_now?.project, dataRender.json_old?.project) && "text-red"
                        }`}
                      >
                        {mapArr(dataRender?.json_now?.project)}
                      </td>
                      <td className={`td-project ${!verefyDiffsInArr(dataRender?.json_now?.client, dataRender.json_old?.client) && "text-red"}`}>
                        {mapArr(dataRender?.json_now?.client)}
                      </td>
                    </>
                  </tr>
                  {/* <hr className="hr-width-history" /> */}
                </>
              )
            );
          })}
        </tbody>
      </TableComponent>
      <ButtonNavigatorComponent
        className="width-select-size"
        list={listModal}
        page={pageModal}
        setPage={setPageModal}
        selectSize={selectSizeModal}
        setSelectSize={setSelectSizeModal}
        selectSizeView={false}
        setPageFirstRender={false}
      />
    </div>
  );
}
